import { langFallback$Fetch } from '../../../../../lang/utils/langfetch'
import { LocationSuggestionRecentSearch } from '../domain/LocationSuggestions'
import {
  RecentSearchResponse,
  recentSearchResponseTypeSchema,
} from '../schemas'

export default class FetchLocationRecentSearchSuggestions {
  async fetch(
    query: string,
    langCode: string,
  ): Promise<LocationSuggestionRecentSearch[]> {
    const token = localStorage.getItem('searchHistoryToken') || ''
    try {
      const response = await langFallback$Fetch<RecentSearchResponse[]>(
        langCode,
        `/search/predictive/recent-search/?q=${query}&token=${token}`,
      )
      return recentSearchResponseTypeSchema.array().parse(response)
    } catch (_) {
      return []
    }
  }
}
